import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { isProduct, ProductId } from "multitenancy/product";

import { usePermissions } from "hooks/permission";

import { useAppSelector } from "store/rootReducer";

import { httpType } from "global/types";

import { ContainerCrud, permitionsCrud } from "features/cruds";
import { IFormOneLabel } from "features/forms/FormOneLabel/interface";
import { IModelFormBase } from "features/forms/optionsForms";
import { AdminAreaSkeleton } from "features/LoadSkeleton";

import api from "services/api";

import { FORMS_ADMIN } from "utils/entities/permission";

export const HearingSource: React.FC = () => {
  const { t } = useTranslation();
  const [onSubmitForm, setOnSubmitForm] = useState<number>(0);
  const [objectRetorned, setObjectRetorned] = useState<IFormOneLabel | null>(
    null,
  );
  const [httpType, setHttpType] = useState<httpType>("post");
  const [listHearingSource, setListHearingSource] = useState<
    Array<IFormOneLabel>
  >([]);

  const [loading, setLoading] = useState<boolean>(true);

  const { user } = useAppSelector((state) => state.user);

  const perms = usePermissions(FORMS_ADMIN.HEARING_SOURCE);
  // TEMP: preview bypass while backend permission is not yet seeded
  const previewBypass =
    isProduct(ProductId.Inquerito) &&
    !perms.read &&
    !perms.create &&
    !perms.edit;
  const read = previewBypass ? true : perms.read;
  const create = previewBypass ? true : perms.create;
  const edit = previewBypass ? true : perms.edit;

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    setLoading(true);
    const hearingSources = await api.get(
      `/v1/HearingSource/GetAllByCustomerId?customerId=${user?.customerId}`,
    );

    setListHearingSource(hearingSources.data.data ?? []);
    setLoading(false);
  }

  const modelFormBase: IModelFormBase = {
    api: api,
    endPoint: "/v1/HearingSource/",
    httpType: httpType,
    setHttpType: setHttpType,
    list: listHearingSource,
    onSubmitForm: onSubmitForm,
    setOnSubmitForm: setOnSubmitForm,
    objectRetorned: objectRetorned,
    setObjectRetorned: setObjectRetorned,
  };

  const formOneLabel: IFormOneLabel = {
    active: true,
    customerId: user?.customerId,
    displayLabel: t("administration.hearingSources.title"),
    id: 0,
    name: "",
    modelFormBase: modelFormBase,
    titleToast: t("administration.hearingSources.title"),
  };

  const permissions: permitionsCrud = {
    inactivate: false,
    toCreate: create,
    toEdit: edit,
    toRead: read,
  };

  return (
    <ContainerCrud
      list={listHearingSource}
      title={t("administration.hearingSources.title")}
      emptyListMessage={t("administration.hearingSources.notFound")}
      permissions={permissions}
      customProsForm={formOneLabel}
      modelFormBase={modelFormBase}
      optionForm="FormOneLabel"
      loading={loading}
      isAudience={t("administration.hearingSources.title")}
      SkeletonComponent={AdminAreaSkeleton}
    />
  );
};
